/**
 * Image optimisation helpers.
 *
 * CloudFront image-resize behaviour is not yet deployed, so these helpers
 * degrade gracefully: appending ?width=&quality= to a plain S3/CloudFront URL
 * that ignores them still returns the original image unmodified.
 */

export const img = (url: string | null | undefined, w = 400, q = 70): string | null | undefined => {
  if (!url) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}width=${w}&quality=${q}`
}

export const srcSet = (url: string | null | undefined, widths = [200, 400, 800]): string | undefined => {
  if (!url) return undefined
  return widths.map((w) => `${img(url, w)} ${w}w`).join(', ')
}
